
/**
 * --- External Imports ---
 */
import { FC, useCallback, useContext, useMemo } from 'react';
import { Outlet, useParams } from 'react-router-dom';

/**
 * --- Internal Imports ---
 */
import Loading from '@/components/layout/Loading';
import { TrialContext } from '@/contexts/data/TrialContext';
import useGetTrialByOid from '@/hooks/data/useGetTrialByOid';
import { ErrorContent } from '@/pages/ErrorPage';
import ServiceStackClientContext from '@/contexts/apis/ServiceStackClientContext';
import { NotifySite, SendSiteEmail } from '@/apis/dtos';


/**
 * --- Trial Provider ---
 */
const TrialProvider: FC = () => {
    const { trialCode } = useParams();

    const trialQuery = useGetTrialByOid(trialCode ? { trialOid: trialCode } : undefined, {});

    const client = useContext(ServiceStackClientContext);

    const emailSite = useCallback(async (trialId?: number, institutionCode?: string, trialCoordinatorIds?: number[]) => {
        // Update document state
        var request = new NotifySite();
        request.trialId = trialId;
        request.institutionCode = institutionCode;
        request.trialCoordinatorIds = trialCoordinatorIds;
        const res = await client.post(request);

        return res;
    }, [client]);
    
    const context = useMemo(() => {
        return {
            ...trialQuery,
            emailSite: emailSite
        }
    }, [trialQuery]);

    return (
        <>
            <Loading name='trial-provider' isLoading={trialQuery.loading} isValidating={trialQuery.validating}/>
            <TrialContext.Provider value={context}>
                {
                    trialQuery.error ?
                        <ErrorContent errorType={trialQuery.error.errorCode ?? "500"} errorMessage={trialQuery.error.message} />:
                        <Outlet />
                }
            </TrialContext.Provider>
        </>
    )
}

export default TrialProvider